module.exports = __webpack_public_path__ + "img/tuition-tutorial-01.f857a73d.png";